module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-1030.4ba09c1f.jpg";